<template>
    <div class="dinema-head">
        <CRow class="w-100 brand-row">
            <CCol xs="12" class="text-start mt-3 brand"><strong>DINEMA</strong></CCol>
        </CRow>
        <CRow class="w-100 brand-row">
            <CCol xs="9" md="11" class="text-start mt-3 brand">
                <CFormInput
                    type="text"
                    id="txtSearch"
                    label=""
                    placeholder="Enter title to search"
                    @input="searchValue = $event.target.value"
                    v-on:keypress.enter="findMovie"
                    v-on:focusout="findMovie"
                    text=""
                    aria-describedby=""
                />
            </CCol>
            <CCol xs="3" md="1" class="text-start mt-3 brand">
                <!-- <CIcon :icon="['fas','solid']" size="xl"/> -->
                <span style="font-size:30px" @click="findMovie">
                    <font-awesome-icon :icon="['fas','magnifying-glass']" />
                </span>
            </CCol>
        </CRow>
    </div>
    <CRow class="mt-5 dinema-content" ref="content">
        <CCol v-for="movie in movieStore.movies" v-bind:key="movie.id" xs="6" md="3" class="mt-4">
            <a :href="getUrl(movie.id)" target="_blank"><CImage rounded fluid :src="movie.poster_image" /></a>
            <!-- <router-link :to="{name: 'movie-detail', query: {target: movie.id} }"></router-link> -->
        </CCol>

        <CCol xs="12" class="mt-4">
            <CPagination align="center" aria-label="Page navigation example">
                <CPaginationItem :disabled="!movieStore.pagination.prevPage" href="#" @click="goto(parseInt(movieStore.pagination.currentPage) - 1)">Prev</CPaginationItem>
                <CPaginationItem v-for="x in movieStore.pages" v-bind:key="x" :disabled="movieStore.pagination.currentPage == x"  href="#" @click="goto(x)">{{ x }}</CPaginationItem>
                <!-- <CPaginationItem href="#">2</CPaginationItem>
                <CPaginationItem href="#">3</CPaginationItem> -->
                <CPaginationItem :disabled="!movieStore.pagination.nextPage" href="#" @click="goto(parseInt(movieStore.pagination.currentPage) + 1)">Next</CPaginationItem>
            </CPagination>
        </CCol>
    </CRow>
</template>
<script>
import { useMovieStore } from '../../stores/movie'

export default {
  name: 'MovieListView',
  setup () {
    const movieStore = useMovieStore()
    const pages = []
    return {
      movieStore,
      pages
    }
  },
  data () {
    return {
      searchValue: ''
    }
  },
  methods: {
    goto (page) {
      this.movieStore.fetchData(page, this.searchValue)
      this.$refs.content.scrollTop = 0
    },
    getUrl (id) {
      var routeData = this.$router.resolve({ name: 'movie-detail', query: { target: id } })
      return routeData.href
    },
    findMovie () {
      if (this.searchValue !== '') {
        this.goto(1)
      }
    }
  },
  mounted () {
    console.log('movie mounted')
    // var currentPage = 1
    // if (this.$route.query.page !== undefined) { currentPage = this.$route.query.page }
    // console.log(currentPage)
    // this.movieStore.fetchData(currentPage)
    this.movieStore.fetchData()
  }
}
</script>
